import React from "react"

const SceneDefault = props => {
  const { children } = props;
  return (
    <div className="scene-default-container">{ children }</div>
  )
};

export default SceneDefault
